/* ═══════════════════════════════════════════════════════════════════════════
   BEAUTYONTAPP — LIQUID GLASS runtime (v3, lean)
   The glass + button feel is pure CSS (works on iPhone). JS only adds two
   progressive extras:
     1. the Chromium-only SVG refraction filter (#lg-distortion) + html.lg-refract
        gate — used solely by opt-in .lg-glass--refract elements.
     2. a desktop-only pointer shine on buttons (--lg-px / --lg-py).
   Idempotent; degrades to nothing if unavailable.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__botLiquidGlass) return;
  window.__botLiquidGlass = true;

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer  = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* 1. inject the refraction filter once (only used by .lg-glass--refract) */
  function injectFilter() {
    if (document.getElementById('lg-distortion')) return;
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
    var f = document.createElementNS(ns, 'filter');
    f.setAttribute('id', 'lg-distortion');
    f.setAttribute('x', '-30%'); f.setAttribute('y', '-30%');
    f.setAttribute('width', '160%'); f.setAttribute('height', '160%');
    f.setAttribute('color-interpolation-filters', 'sRGB');
    var t = document.createElementNS(ns, 'feTurbulence');
    t.setAttribute('type', 'turbulence'); t.setAttribute('baseFrequency', '0.012');
    t.setAttribute('numOctaves', '2'); t.setAttribute('seed', '7'); t.setAttribute('result', 'n');
    var g = document.createElementNS(ns, 'feGaussianBlur');
    g.setAttribute('in', 'n'); g.setAttribute('stdDeviation', '0.5'); g.setAttribute('result', 's');
    var d = document.createElementNS(ns, 'feDisplacementMap');
    d.setAttribute('in', 'SourceGraphic'); d.setAttribute('in2', 's');
    d.setAttribute('scale', '60'); d.setAttribute('xChannelSelector', 'R'); d.setAttribute('yChannelSelector', 'G');
    f.appendChild(t); f.appendChild(g); f.appendChild(d); svg.appendChild(f);
    (document.body || root).appendChild(svg);
  }

  function detectRefraction() {
    if (reduceMotion || !('CSS' in window) || !CSS.supports) return;
    if (CSS.supports('backdrop-filter', 'url(#lg-distortion)') ||
        CSS.supports('-webkit-backdrop-filter', 'url(#lg-distortion)')) {
      root.classList.add('lg-refract');   // Chromium only; Safari/FF stay on the CSS baseline
    }
  }

  /* 2. desktop pointer shine on buttons */
  var SEL = '.button,.cdw-auth-btn,.lg-glass-btn';
  var el = null, px = 50, py = 50, tick = false;
  function paint() { tick = false; if (el) { el.style.setProperty('--lg-px', px + '%'); el.style.setProperty('--lg-py', py + '%'); } }
  function move(e) {
    var t = e.target.closest && e.target.closest(SEL);
    el = t;
    if (!t) return;
    var r = t.getBoundingClientRect();
    if (!r.width) return;
    px = ((e.clientX - r.left) / r.width) * 100;
    py = ((e.clientY - r.top) / r.height) * 100;
    if (!tick) { tick = true; requestAnimationFrame(paint); }
  }

  function init() {
    injectFilter();
    detectRefraction();
    if (finePointer && !reduceMotion) document.addEventListener('pointermove', move, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
